import { Card } from 'lucid-components-react';
import React from 'react';

import { Drupal_ParagraphFullCard } from '../../generated/graphql';
import { getProcessedValue } from '../../utils/helpers';
import Link from '../link/link';
import './cards.scss';

interface CardsProps {
  cards: Drupal_ParagraphFullCard[];
}

const Cards = ({ cards }: CardsProps) => {
  return (
    <section className="card-component lucid-container lucid-container--flex">
      {cards.map(
        ({ fieldCtaHeading, fieldLink, fieldImage, fieldCardSubheader }) => {
          return (
            <div key={fieldCtaHeading!} className="card--thirds">
              <Card isInteractive className="card">
                <Link
                  className="card__wrapper"
                  to={fieldLink!}
                  underline="none"
                >
                  {fieldImage && (
                    <Card.Image className="card__image">
                      <div
                        className="card__thumbnail"
                        style={{
                          backgroundImage: `url(${fieldImage})`,
                          height: '100%'
                        }}
                      />
                    </Card.Image>
                  )}
                  <Card.Content className="card__contents">
                    <Card.Title>{fieldCtaHeading}</Card.Title>
                    {fieldCardSubheader && (
                      <div
                        className={`card__description ${
                          fieldImage ? '' : 'card__description--wrap'
                        }`}
                        dangerouslySetInnerHTML={{
                          __html: getProcessedValue(fieldCardSubheader)
                        }}
                      />
                    )}
                  </Card.Content>
                </Link>
              </Card>
            </div>
          );
        }
      )}
    </section>
  );
};

export default Cards;
